import React from "react";
import styles from "./styles.module.scss";

const RightArrow = () => (
  <svg
    className={styles.rightArrow}
    width="38px"
    height="38px"
    viewBox="0 0 38 38"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="group-2-copy">
        <g
          id="Group"
          transform="translate(19.000000, 19.000000) scale(-1, 1) translate(-19.000000, -19.000000) "
        >
          <circle
            id="Oval"
            fill="#FFFFFF"
            fillRule="nonzero"
            cx="19"
            cy="19"
            r="19"
          />
          <polyline
            id="Path"
            stroke="#AAAAAA"
            strokeWidth="2"
            strokeLinecap="square"
            transform="translate(18.750000, 19.000000) scale(-1, 1) translate(-18.750000, -19.000000) "
            points="16 24 21.5 18.663 16 14"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default RightArrow;
